import { useState, useEffect } from "react";

import {
  ArrowRight,
  Newspaper,
  FileText,
  Globe2,
  Building2,
  Mic2,
} from "lucide-react";

import { TICKER_ITEMS } from "../data/navData";
import heroBg from "../assets/hero-bg.png"

export default function HeroSection() {
  // Ticker Data
  const tickerData = [
    { text: TICKER_ITEMS[0], icon: Globe2 },
    { text: TICKER_ITEMS[1], icon: FileText },
    { text: TICKER_ITEMS[2], icon: Newspaper },
    { text: TICKER_ITEMS[3], icon: Building2 },
    { text: TICKER_ITEMS[4], icon: FileText },
    { text: TICKER_ITEMS[5], icon: Mic2 },
    { text: TICKER_ITEMS[6], icon: Newspaper },
    { text: TICKER_ITEMS[7], icon: Globe2 },
    { text: TICKER_ITEMS[8], icon: Building2 },
  ];

  const horizontalTicker = [...tickerData, ...tickerData];

  // Slider Data
  const originalCards = [
    {
      img: "https://www.assocham.org/assets/images/slider-banners/1780298538_VGRC%20South%20Gujarat_2026_1.jpg",
      title: "Shri Nirmal Kumar Minda, President, ASSOCHAM, along with Shri D. S. Rajora, DSG, ASSOCHAM, held a one-to-one meeting with Shri Bhupendrabhai Patel, Hon’ble Chief Minister of Gujarat, during the VGRC South Gujarat event",
      date: "December 18, 2025 · New Delhi",
    },
    {
      img: "https://www.assocham.org/assets/images/slider-banners/1780298549_VGRC%20South%20Gujarat_2026.jpg",
      title: "Shri Nirmal Kumar Minda, President, ASSOCHAM, presenting a memento to Shri Bhupendrabhai Patel, Hon’ble Chief Minister of Gujarat, during their meeting at VGRC South Gujarat",
      date: "January 2026 · South Gujarat",
    },
    {
      img: "https://www.assocham.org/assets/images/slider-banners/1780294169_Untitled%20design%20(7).jpg",
      title: "ASSOCHAM President and SG along with team UNO Minda and ASSOCHAM met Shri Tarun Kapoor, Advisor to the Hon PM at Seva Teerth",
      date: "March 2026 · Bengaluru",
    },
  ];

  const cards = [...originalCards, originalCards[0]];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(true);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (isPaused) return;
    const timer = setInterval(() => handleNext(), 5000);
    return () => clearInterval(timer);
  }, [isPaused, currentIndex]);

  const handleNext = () => {
    setIsTransitioning(true);
    setCurrentIndex((prev) => prev + 1);
  };

  const handleTransitionEnd = () => {
    if (currentIndex >= cards.length - 1) {
      setIsTransitioning(false);
      setCurrentIndex(0);
      setTimeout(() => setIsTransitioning(true), 50);
    }
  };

  return (
    // <section
    //   id="home"
    //   className="relative overflow-hidden bg-gradient-to-br from-[#fff] via-white to-[#fff]"
    // >
     <section
  className="relative mb-20 bg-no-repeat bg-bottom"
  style={{
    // backgroundImage: `url(${heroBg})`,
    background: "#FAF7F2",
    backgroundSize: "cover",
    backgroundPosition: "center bottom",
    backgroundAttachment: "fixed",
  }}
>
      <div className="mx-auto px-6 py-20 lg:py-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">

          {/* LEFT CONTENT */}
          <div className="space-y-6">
            {/* <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-orange-100 text-orange-700 text-[14px] font-medium">
              Driving India’s Business Future
            </div> */}

            <h1 className="text-5xl lg:text-4xl font-bold leading-tight text-gray-900">
              The Voice of{" "}
              <span className="text-[#da2128]">Indian Industry</span>
              {/* <span className="text-[#B5121B]">Indian Industry</span> */}
            </h1>

           <h2 className="text-4xl lg:text-4xl font-semibold text-[#faa61a] leading-tight !mt-[10px]">
            {/* <h2 className="text-4xl lg:text-3xl font-semibold text-[#E8A83A] leading-tight -mt-2"> */}
              Shaping Bharat's Future
            </h2>

            <p className="text-[18px] text-gray-600 max-w-lg">
              The Associated Chambers of Commerce & Industry of India (ASSOCHAM) has been at the forefront of strengthening India's economic landscape for over a century.
            </p>

            <div className="flex flex-wrap gap-4 pt-4">
              <a
                href="#knowledge"
                className="inline-flex items-center gap-2 px-8 py-3.5 hover:bg-[#f59c00] hover:text-white  font-semibold rounded-xl border-2 border-[#f7941d] hover:border-white transition-all duration-300"
              >
                Explore
                <ArrowRight className="w-5 h-5" />
              </a>
            </div>
            {/* <div className="flex flex-wrap gap-4 pt-4">
              <a
                href="#knowledge"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-[#B5121B] hover:bg-[#f59c00] text-white font-semibold rounded-xl transition-all"
              >
                Explore
                <ArrowRight className="w-5 h-5" />
              </a>
            </div> */}
          </div>

          {/* RIGHT SIDE - SLIDER (Height Reduced) */}
          <div className="relative">
            <div
              className="relative rounded-3xl overflow-hidden shadow-2xl"
              style={{ boxShadow: "2px 2px 2px 2px #9c9999" }}
              onMouseEnter={() => setIsPaused(true)}
              onMouseLeave={() => setIsPaused(false)}
            >
              <div className="relative h-[430px] lg:h-[440px] rounded-3xl" >
                <div
                  className="flex h-full w-full"
                  onTransitionEnd={handleTransitionEnd}
                  style={{
                    transform: `translateX(-${currentIndex * 100}%)`,
                    transition: isTransitioning ? "transform 1000ms cubic-bezier(0.4, 0, 0.2, 1)" : "none",
                  }}
                >
                  {cards.map((card, i) => (
                    <div key={i} className="relative h-full w-full shrink-0">
                      <img
                        src={card.img}
                        alt={card.title}
                        className="w-full h-full object-cover"
                        loading="eager"
                      />
                      <div className="absolute inset-0 " />
                      <div className="absolute bottom-3 left-5 right-5 text-white">
  <div className="font-serif text-xs lg:text-sm leading-snug bg-black/60 backdrop-blur-md px-2.5 py-1.5 rounded-md inline-block">
    {card.title}
  </div>

  {/* <div className="text-xs mt-2 text-white/80 font-medium">
    {card.date}
  </div> */}
</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>


      {/* Bottom Floating Ticker */}
<div className="absolute bottom-0 left-0 w-full z-20 translate-y-1/2 px-6">
  <div className="max-w-8xl mx-auto">
    <div className="bg-[#FFFFFF] backdrop-blur-xl border border-[#FFFFFF] shadow-2xl rounded-2xl overflow-hidden">
      
      <div className="flex items-center pr-[18px]">
        
        {/* LIVE UPDATE LABEL */}
        <div className="bg-[#da2128]/50 hover:bg-[#da2128] hover:text-white px-4 py-4 flex items-center gap-2 font-semibold text-xs sm:text-sm whitespace-nowrap rounded-r-2xl shadow-lg min-w-fit ">
          <span className="w-2 h-2 bg-[#FFFFFF] rounded-full animate-pulse" />
          LIVE UPDATES
        </div>

        {/* TICKER */}
        <div className="flex-1 overflow-hidden px-4">
          <div className="flex items-center gap-8 whitespace-nowrap animate-[tickerHorizontal_40s_linear_infinite] hover:[animation-play-state:paused] py-3">
            {horizontalTicker.map((item, i) => {
              const Icon = item.icon;

              return (
                <a
                  key={i}
                  href="#knowledge"
                  className="flex items-center gap-2 text-gray-700 hover:text-[#B5121B] transition-colors m-[5px]"
                >
                  <Icon className="w-4 h-4" />
                  <span className="text-sm font-medium">
                    {item.text}
                  </span>
                </a>
              );
            })}
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

      <style jsx>{`
        @keyframes tickerHorizontal {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </section>
  );
}